import InputDateTime from "../../../../components/input/input-datetime.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {
    const {
        occurrenceDetailsNature,
        occurrenceVehicleClassification,
        occurrenceCityFact,
    } = useReportFiltersFetch({
        fetchOccurrenceDetailsNature: true,
        fetchOccurrenceVehicleClassification: true,
        fetchOccurrenceCityFact: true,
    });

    const monitoredVehicleOptions = [
        { value: "true", label: "Sim" },
        { value: "false", label: "Não" },
    ]

    const occurrenceStatusOptions = [
        { value: "ACTIVE", label: "Ativa" },
        { value: "CONCLUDED", label: "Concluída" },
    ]

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className="space-y-4">
                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        dateFormat="L"
                        classNameWrapper="w-full"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                    />
                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        dateFormat="L"
                        classNameWrapper="w-full"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                    />
                    <SelectComponent
                        id="reason"
                        label="Natureza"
                        classNameWrapper="w-full"
                        wrapValues={true}
                        isClearable={true}
                        isMulti={true}
                        options={occurrenceDetailsNature}
                        value={filters.reason}
                        onChange={(value) => setFilters(prev => ({ ...prev, reason: value }))}
                    />
                    <SelectComponent
                        id="monitoredVehicle"
                        label="Veículo monitorado"
                        classNameWrapper="w-full"
                        isClearable={true}
                        options={monitoredVehicleOptions}
                        value={filters.monitoredVehicle}
                        onChange={(value) => setFilters(prev => ({ ...prev, monitoredVehicle: value }))}
                    />
                    <SelectComponent
                        id="occurrenceStatus"
                        label="Status da ocorrência"
                        classNameWrapper="w-full"
                        isClearable={true}
                        options={occurrenceStatusOptions}
                        value={filters.occurrenceStatus}
                        onChange={(value) => setFilters(prev => ({ ...prev, occurrenceStatus: value }))}
                    />
                    <SelectComponent
                        id="vehicleClassif"
                        label="Classificação dos veículos na ocorrência"
                        classNameWrapper="w-full"
                        wrapValues={true}
                        isClearable={true}
                        isMulti={true}
                        options={occurrenceVehicleClassification}
                        value={filters.vehicleClassif}
                        onChange={(value) => setFilters(prev => ({ ...prev, vehicleClassif: value }))}
                    />
                    <SelectComponent
                        id="cityFact"
                        label="Município do fato"
                        classNameWrapper="w-full"
                        wrapValues={true}
                        isClearable={true}
                        isMulti={true}
                        options={occurrenceCityFact}
                        value={filters.cityFact}
                        onChange={(value) => setFilters(prev => ({ ...prev, cityFact: value }))}
                    />
                    <InputCheckbox
                        id="archivedOccurrences"
                        label="Contabilizar ocorrências arquivadas"
                        className="pl-1"
                        checked={filters.archivedOccurrences}
                        onChange={(e) => setFilters(prev => ({ ...prev, archivedOccurrences: e.target.checked }))}
                    />
                    <InputCheckbox
                        id="onlyMyCity"
                        label="Apenas ocorrências da minha corporação"
                        className="pl-1"
                        checked={filters.onlyMyCity}
                        onChange={(e) => setFilters(prev => ({ ...prev, onlyMyCity: e.target.checked }))}
                    />
                </form>
            </div>
        </>
    )
}